<template>
  <van-popup v-model="showPicker" round :position="position">
    <van-picker
      :title="title"
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="onCancel"
      :default-index="index"
    />
  </van-popup>
</template>

<script>
    export default {
        name: "comchoice",
      props: {
        //标题
        title: {
          type: String,
          default: ''
        },
        //弹出方向
        position: {
          type: String,
          default: 'bottom'
        },
        //类型
        type: {
          type: String,
          default: ''
        },
        //字段
        zd: {
          type: String,
          default: ''
        },
        //内容
        nr: {
          type: String,
          default: ''
        },
        //字段2
        zd2: {
          type: String,
          default: ''
        },
        //内容2
        nr2: {
          type: String,
          default: ''
        },
        //字段3
        zd3: {
          type: String,
          default: ''
        },
        //内容3
        nr3: {
          type: String,
          default: ''
        },
        callbak: {
          type: Function,
          default: null,
        }

      },
      data() {
        return {
          showPicker:false,
          value:null,
          text:null,
          columns:[],
          index:0,
          dm:null,

        }
      },
      created() {
      },
      methods: {
        show(show,dm,method){
          this.showPicker = show;
          this.dm = dm;
          this.getlist();
        },
        getlist(){
          let that = this;
          let datas = {
            type:that.type,
            zd:that.zd,
            nr:that.nr,
            zd2:that.zd2,
            nr2:that.nr2,
            zd3:that.zd3,
            nr3:that.nr3,
          };
          this.$ajax.post('/appapi/appcom/choicelx',datas).then(function (rep) {
            if (rep.code == 200) {
              that.columns = rep.columnsList;
              for(var i = 0;i < that.columns.length;i++){
                if(that.dm === that.columns[i].value){
                  that.index = i;
                }
              }
            }
          });
        },
        onConfirm(columns, index) {
          this.value = columns.value;
          this.text = columns.text;
          this.index = index;
           this.callbak(this.value,this.text);
          this.showPicker = false;
        },
        onCancel() {
          this.showPicker = false;
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/choice/comchoice.vue